<template>
  <div class="role-distribution-comparison">
    <RoleDistributionCard
        class="pdf-avoid-break"
        :period-label="previousLabel"
        title="Распределение ролей"
        description="Количество человек в каждой группе."
        :items="previousItems"
    />

    <RoleDistributionCard
        class="pdf-avoid-break"
        :period-label="currentLabel"
        tag-type="current"
        title="Распределение ролей"
        description="Количество человек в каждой группе."
        :items="currentItems"
    />
  </div>
</template>

<script>


import RoleDistributionCard from "@/views/Report/CompareReport/RoleDistributionCard.vue";

export default {
  name: 'RoleDistributionComparisonBlock',

  components: {
    RoleDistributionCard

  },

  props: {
    previousLabel: {
      type: String,
      default: 'Было',
    },

    currentLabel: {
      type: String,
      default: 'Стало',
    },

    previousItems: {
      type: Array,
      default: () => [],
    },

    currentItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.role-distribution-comparison {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: $tablet-breakpoint) {
  .role-distribution-comparison {
    grid-template-columns: 1fr;
  }
}
</style>